module.exports = __webpack_public_path__ + "img/btn1.0b3f7a70.png";